/* @flow */
import React from 'react';

/* Simple component to describe to structure
 * of a AsyncSelectItem, thoses are the thing that
 * must be passed back in AsyncSelect#searchCallback.
 */
class AsyncSelectItem extends React.Component {
  /*
   * title - The string showed in the input afters selecting a results
   * id - The unique identifier of the object (REACTJS keys)
   * childrens are The DOM elements of the result box.
   */
  static propTypes = {
    title: React.PropTypes.string.isRequired,
    id: React.PropTypes.number,
  };

  render() {
    return this.props.children;
  }
}

export default AsyncSelectItem;



// WEBPACK FOOTER //
// ./src/components/AsyncSelectItem.jsx